import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as CommitteeRegularInviteeActions from "../../../actions/committeeRegularInvitee";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import { TextAreaFormInput } from "../../../components/form";
import { SelectFormInput } from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { createPersonnelSearchLoader } from "../../../functions/personnel";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { CommitteeRegularInviteeCreateBreadcrumbs, CommitteeRegularInviteeDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { CommitteeRegularInviteeSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { ICommitteeRegularInviteeReduxFormState } from "../../../reducers/reactReduxForms/committeeRegularInvitee";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./CommitteeRegularInviteePage.scss";

interface CommitteeRegularInviteePageProps {
    form: Dtos.CommitteeRegularInvitee & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ICommitteeRegularInviteeReduxFormState;
    committeeRegularInvitee: Dtos.CommitteeRegularInvitee;
    committee: Dtos.Committee | undefined;
    lookups: Dtos.Lookup[];
    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;
    loadingCommitteeRegularInvitee: boolean;
    loadCommitteeRegularInviteeSuccess: boolean;
    loadCommitteeRegularInviteeFailure: boolean;
    loadCommitteeRegularInviteeErrorCode: string;
    savingCommitteeRegularInvitee: boolean;
    saveCommitteeRegularInviteeSuccess: boolean;
    saveCommitteeRegularInviteeFailure: boolean;
    creatingCommitteeRegularInvitee: boolean;
    createCommitteeRegularInviteeSuccess: boolean;
    createCommitteeRegularInviteeFailure: boolean;
    validatingCommitteeRegularInvitee: boolean;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearCommitteeRegularInvitee: CommitteeRegularInviteeActions.ICommitteeRegularInviteeClearActionCreator;
    loadCommitteeRegularInvitee: CommitteeRegularInviteeActions.ICommitteeRegularInviteeLoadByIdActionCreator;
    saveCommitteeRegularInvitee: CommitteeRegularInviteeActions.ICommitteeRegularInviteeSaveActionCreator;
    createCommitteeRegularInvitee: CommitteeRegularInviteeActions.ICommitteeRegularInviteeCreateActionCreator;
    validateCommitteeRegularInvitee: CommitteeRegularInviteeActions.ICommitteeRegularInviteeValidateActionCreator;
    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.committeeRegularInvitee";

const CommitteeRegularInviteePage: FC<CommitteeRegularInviteePageProps> = ({
    form,
    formState,
    formProperties,
    //reduxFormState,
    committeeRegularInvitee,
    committee,
    lookups,
    loadingCommittee,
    //loadCommitteeSuccess,
    loadCommitteeFailure,
    loadCommitteeErrorCode,
    loadingCommitteeRegularInvitee,
    //loadCommitteeRegularInviteeSuccess,
    loadCommitteeRegularInviteeFailure,
    loadCommitteeRegularInviteeErrorCode,
    savingCommitteeRegularInvitee,
    saveCommitteeRegularInviteeSuccess,
    saveCommitteeRegularInviteeFailure,
    creatingCommitteeRegularInvitee,
    //createCommitteeRegularInviteeSuccess,
    //createCommitteeRegularInviteeFailure,
    validatingCommitteeRegularInvitee,
    validationFailures,
    permissions,
    clearCommitteeRegularInvitee,
    loadCommitteeRegularInvitee,
    saveCommitteeRegularInvitee,
    createCommitteeRegularInvitee,
    validateCommitteeRegularInvitee,
    clearCommittee,
    loadCommittee,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { committeeId } = useParams<{ committeeId: string }>();
    const { committeeRegularInviteeId } = useParams<{ committeeRegularInviteeId: string }>();
    const committeeIdNumber = parseInt(committeeId, 10);
    const committeeRegularInviteeIdNumber = parseInt(committeeRegularInviteeId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.CommitteeRegularInvitee = {} as Dtos.CommitteeRegularInvitee;

        loadForm(reduxFormName, Object.assign({ ...committeeRegularInvitee }, extraData));
    };


    // Load/Create committee regular invitee
    useEffect(() => {
        if (committeeRegularInviteeIdNumber && !committeeRegularInvitee && !loadingCommitteeRegularInvitee) {
            setDrawerItems(
                CommitteeRegularInviteeSubMenu(
                    committeeIdNumber,
                    committeeRegularInviteeIdNumber,
                    permissions
                )
            );
            setBreadcrumbs(
                CommitteeRegularInviteeDetailsBreadcrumbs(
                    committeeIdNumber,
                    committeeRegularInviteeIdNumber
                )
            );
            loadCommitteeRegularInvitee(committeeRegularInviteeIdNumber);
        } else if (!committeeRegularInviteeIdNumber && !committeeRegularInvitee && !creatingCommitteeRegularInvitee) {
            setDrawerItems([]);
            setBreadcrumbs(
                CommitteeRegularInviteeCreateBreadcrumbs(
                    committeeIdNumber,
                    committeeRegularInviteeIdNumber
                )
            );
            createCommitteeRegularInvitee(committeeIdNumber);
        } else if (committeeRegularInvitee && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        committeeRegularInviteeIdNumber,
        committeeRegularInvitee,
        loadingCommitteeRegularInvitee,
        committeeIdNumber,
        permissions,
        creatingCommitteeRegularInvitee,
        initalised
    ]);

    // Load committee
    useEffect(() => {
        if (committeeIdNumber && !committee && !loadingCommittee) {
            loadCommittee(committeeIdNumber);
        }
    }, [committeeIdNumber, committee, loadingCommittee]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadCommitteeRegularInviteeFailure) {
            navigate(`/error/${loadCommitteeRegularInviteeErrorCode}`);
        }
        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
    }, [
        loadCommitteeRegularInviteeFailure,
        loadCommitteeRegularInviteeErrorCode,
        loadCommitteeFailure,
        loadCommitteeErrorCode
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (committeeRegularInviteeIdNumber && committeeIdNumber && committeeRegularInvitee && committee) {
            setBreadcrumbs(
                CommitteeRegularInviteeDetailsBreadcrumbs(
                    committeeIdNumber,
                    committeeRegularInviteeIdNumber,
                    committee.name,
                    committeeRegularInvitee?.personnel?.displayWithSalutation
                )
            );
        }
        else if (!committeeRegularInviteeIdNumber && committeeIdNumber && committee) {
            setBreadcrumbs(
                CommitteeRegularInviteeCreateBreadcrumbs(
                    committeeIdNumber,
                    committeeRegularInviteeIdNumber,
                    committee?.name
                )
            );
        }
    }, [
        committeeRegularInviteeIdNumber,
        committeeIdNumber,
        committeeRegularInvitee,
        committee
    ]);

    // Reload personnel after saving
    useEffect(() => {
        if (!savingCommitteeRegularInvitee && saveCommitteeRegularInviteeSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Committee Regular Invitee saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/committees/${committeeIdNumber}/regularinvitees`);
            } 
            else if (!committeeRegularInviteeIdNumber) {
                navigate(`/committees/${committeeIdNumber}/regularinvitees/${committeeRegularInvitee.id}/details`);
                clearCommitteeRegularInvitee();
            }
        }
    }, [
        savingCommitteeRegularInvitee,
        saveCommitteeRegularInviteeSuccess,
        saveAndReturn,
        committeeRegularInvitee,
        committeeRegularInviteeIdNumber,
        committeeIdNumber
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingCommitteeRegularInvitee && saveCommitteeRegularInviteeFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingCommitteeRegularInvitee, saveCommitteeRegularInviteeFailure]);

    // Cleanup effect to clear the committee regular invitee on component unmount
    useEffect(() => {
        return () => {
            clearCommitteeRegularInvitee();
            clearCommittee();
            resetForm(reduxFormName);
        };
    }, [clearCommitteeRegularInvitee, clearCommittee, resetForm, reduxFormName]);

    const onCancel = () => {
        navigate(`/committees/${committeeIdNumber}/regularinvitees`);
    };

    const handleOnSubmitFailed = (_data: Dtos.CommitteeRegularInvitee) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.CommitteeRegularInvitee = {} as Dtos.CommitteeRegularInvitee;

            await saveCommitteeRegularInvitee(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
        useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.CommitteeRegularInvitee = {} as Dtos.CommitteeRegularInvitee;

            if (form && hasBeenSubmitted && !validatingCommitteeRegularInvitee) {
                await validateCommitteeRegularInvitee(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const personnelSearchLoader = useMemo(() => {
        return createPersonnelSearchLoader(
            form?.personnel 
                ? { label: form?.personnel?.displayWithSalutation, value: form?.personnelId } as Dtos.PersonnelOption 
                : null
        );
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeRegularInviteeUpdate
        );
        const formDisabled: boolean =
            !hasPermission ||
            savingCommitteeRegularInvitee ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row py-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeRegularInvitee",
                                        {
                                            personnelId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    value: form?.personnelId ?? null,
                                                    cacheOptions: true,
                                                    defaultOptions: form?.personnel
                                                        ? [{ label: form.personnel.displayWithSalutation, value: form.personnel.id }]
                                                        : true,
                                                    placeholder: "Type to search for personnel...",
                                                    clearable: true,
                                                    loadOptions: personnelSearchLoader,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            commentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Comments</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeRegularInvitee",
                                        {
                                            comment: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "committeeRegularInvitee",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary mr-2"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        permissions,
        savingCommitteeRegularInvitee,
        formState,
        form,
        personnelSearchLoader,
        lookups,
        validationFailures,
        formProperties,
        changeForm,
        reduxFormName,
        handleOnSubmit,
        handleOnSubmitFailed,
        onCancel
    ]);

    return (
        <RestrictedLayout
            loading={
                loadingCommitteeRegularInvitee ||
                creatingCommitteeRegularInvitee || 
                loadingCommittee
            }
            permission={Dtos.Permission.CommitteeRegularInviteeView}
        >
            { renderContent }
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<CommitteeRegularInviteePageProps> => {
    let committeeRegularInvitee: Dtos.CommitteeRegularInvitee | undefined = !(state.committeeRegularInvitee.formData instanceof Array)
        ? state.committeeRegularInvitee.formData
        : undefined;
    let committee: Dtos.Committee | undefined = !(state.committees.formData instanceof Array)
        ? state.committees.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        committeeRegularInvitee: committeeRegularInvitee!,
        committee: committee!,

        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        loadingCommitteeRegularInvitee:
            state.committeeRegularInvitee.loadState &&
            state.committeeRegularInvitee.loadState.status == RequestState.Pending,
        loadCommitteeRegularInviteeSuccess:
            state.committeeRegularInvitee.loadState &&
            state.committeeRegularInvitee.loadState.status == RequestState.Success,
        loadCommitteeRegularInviteeFailure:
            state.committeeRegularInvitee.loadState &&
            state.committeeRegularInvitee.loadState.status == RequestState.Failure,
        loadCommitteeRegularInviteeErrorCode:
            state.committeeRegularInvitee.loadState.errorCode,

        savingCommitteeRegularInvitee:
            state.committeeRegularInvitee.saveState &&
            state.committeeRegularInvitee.saveState.status == RequestState.Pending,
        saveCommitteeRegularInviteeSuccess:
            state.committeeRegularInvitee.saveState &&
            state.committeeRegularInvitee.saveState.status == RequestState.Success,
        saveCommitteeRegularInviteeFailure:
            state.committeeRegularInvitee.saveState &&
            state.committeeRegularInvitee.saveState.status ==
                RequestState.Failure,

        creatingCommitteeRegularInvitee:
            state.committeeRegularInvitee.createState &&
            state.committeeRegularInvitee.createState.status == RequestState.Pending,
        createCommitteeRegularInviteeSuccess:
            state.committeeRegularInvitee.createState &&
            state.committeeRegularInvitee.createState.status == RequestState.Success,
        createCommitteeRegularInviteeFailure:
            state.committeeRegularInvitee.createState &&
            state.committeeRegularInvitee.createState.status == RequestState.Failure,

        validatingCommitteeRegularInvitee:
            state.committeeRegularInvitee.validateState &&
            state.committeeRegularInvitee.validateState.status == RequestState.Pending,

        permissions: permissions,
        lookups: state.committeeRegularInvitee.lookups,

        form: state.reduxForms.committeeRegularInvitee,
        formState: state.committeeRegularInvitee.formState,
        formProperties: state.committeeRegularInvitee.formProperties,

        reduxFormState: state.reduxForms.formState.committeeRegularInvitee,
        validationFailures: committeeRegularInvitee
            ? state.committeeRegularInvitee.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<CommitteeRegularInviteePageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadCommitteeRegularInvitee: bindActionCreators(
            CommitteeRegularInviteeActions.LoadCommitteeRegularInviteeById,
            dispatch
        ),
        clearCommitteeRegularInvitee: bindActionCreators(
            CommitteeRegularInviteeActions.Clear,
            dispatch
        ),

        loadCommittee: bindActionCreators(CommitteeActions.LoadCommitteeById, dispatch),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        saveCommitteeRegularInvitee: bindActionCreators(
            CommitteeRegularInviteeActions.SaveCommitteeRegularInvitee,
            dispatch
        ),
        createCommitteeRegularInvitee: bindActionCreators(
            CommitteeRegularInviteeActions.CreateCommitteeRegularInvitee,
            dispatch
        ),
        validateCommitteeRegularInvitee: bindActionCreators(
            CommitteeRegularInviteeActions.ValidateCommitteeRegularInvitee,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommitteeRegularInviteePage);
